import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, Output, EventEmitter } from "@angular/core";
import { PartnerNamesEnum } from "../shared";


@Component({
    selector: 'app-accordion',
    templateUrl: "./accordion.component.html",
    styleUrls: ["./accordion.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class AccordionComponent implements OnInit {
    @Input() partnerName: string = "";
    @Input() section: number;
    @Input() title: string;
    @Input() expanded: boolean = false;
    @Input() showExpand: boolean = true;
    @Input() showTitle: boolean = true;

    @Output() onToggleExpanded = new EventEmitter();



    get stepImagePath() {
        switch (this.partnerName) {
            case PartnerNamesEnum.FOUR_20_PHARMA:
                return "private/420pharma";
            default:
                return "medizinisches";
        }
    }

    constructor(private cd: ChangeDetectorRef) { }

    ngOnInit(): void {
    }

    toggleExpanded() {
        if (this.showExpand) {
            this.expanded = !this.expanded;
            this.onToggleExpanded.emit(this.expanded);
        }
    }
}
